<template>
  <v-row>
    <v-col cols="12" md="6">
      <form-group :validator="$v.form.name" name="name" attribute="fields.name">
        <template slot-scope="{ attrs, listeners }">
          <v-text-field
            type="text"
            dense
            v-bind="attrs"
            v-on="listeners"
            outlined
            v-model="form.name"
            :messages="$t('required')"
          ></v-text-field>
        </template>
      </form-group>
    </v-col>
    <v-col cols="12" md="6">
      <form-group
        :validator="$v.form.sub_name"
        name="sub_name"
        attribute="fields.sub_name"
      >
        <template slot-scope="{ attrs, listeners }">
          <v-text-field
            type="text"
            dense
            v-bind="attrs"
            v-on="listeners"
            outlined
            v-model="form.sub_name"
          ></v-text-field>
        </template>
      </form-group>
    </v-col>
    <v-col cols="12" md="6">
      <v-label>{{ $t("fields.bg_color") }}</v-label>
      <v-color-picker
        mode="hexa"
        hide-mode-switch
        v-model="form.color"
        :value="form.color"
      ></v-color-picker>
    </v-col>
    <v-col cols="12" md="6">
      <v-switch
        :label="$t('table.visible')"
        :true-value="1"
        :false-value="0"
        v-model="form.visible"
      ></v-switch>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "FirstStep",
  props: {
    form: {
      type: Object,
      default: () => {}
    }
  },
  inject: ["$v"]
};
</script>
